import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { BrUserAuthoritiesType } from 'types/BrTypes';
import { getUserAuthorities } from 'services/businessRelationService';

export const useFetchBrUserAuthorities = () => {
  return useQuery<BrUserAuthoritiesType[], AxiosError>({
    queryKey: ['getUserAuthorities'],
    queryFn: () => getUserAuthorities(),
  });
};
